// extracted by mini-css-extract-plugin
export var container = "_ga-0";